export default __webpack_public_path__ + "static/media/kioskCardIcon.28928150.svg";